<script setup>
import { ref, defineProps, onMounted } from 'vue'
import PlaceInformation from '@/components/object_placeCollection/templates/placeInformation.vue'
import { formatDate } from '@/mixins/global/globalPlaces'

const props = defineProps({
    placeInformation: {
        type: Object,
        default: null
    }
})

const dayDate = ref('')
const activePlaces = ref([])
const weatherData = ref(null)

onMounted(() => {
    if (props.placeInformation && Object.keys(props.placeInformation).length > 0) {
        const today = new Date().toISOString().split('T')[0]

        const availableDates = Object.keys(props.placeInformation).sort()

        if (availableDates.includes(today)) {
            dayDate.value = today
        } else {
            dayDate.value = availableDates[0]
        }

        activePlaces.value = props.placeInformation[dayDate.value]?.places ?? []
        weatherData.value = props.placeInformation[dayDate.value]?.weather ?? null
    }
})
</script>

<template>
    <div class="day-overview-container">
        <div v-if="!placeInformation || Object.keys(placeInformation).length === 0" class="places-empty">
            Keine Platzinformationen verfügbar.
        </div>

        <template v-else>
            <div v-if="dayDate" class="day-date-header">
                Platzstatus am {{ formatDate(dayDate, true) }}
            </div>

            <div class="places">
                <div v-for="(place, index) in activePlaces"
                     :key="index"
                     class="item-status-box"
                     :class="{ 'open': place.open, 'closed': !place.open }">
                    <div class="item-header">
                        <span class="item-name">{{ place.name }}</span>
                    </div>
                    <place-information :place="place"/>
                </div>

                <div v-if="weatherData?.weather?.[0]" class="item-status-box">
                    <div class="item-header">
                        <span class="item-name">Wetter</span>
                    </div>
                    <div class="item-info weather-info">
                        <img :src="'https://openweathermap.org/img/wn/' + weatherData.weather[0].icon + '.png'"
                             :alt="weatherData.weather[0].description"
                             class="weather-icon">
                        <span class="item-value">
                            {{ weatherData.temp ? Math.floor(weatherData.temp.day) + ' °C' : 'N/A' }}
                        </span>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<style scoped lang="scss">
.day-date-header {
    margin-bottom: 1rem;
}

.places {
    display: flex;
    align-items: flex-start;
    flex-wrap: wrap;
    gap: 1rem;
}

.item-status-box {
    border: 1px solid #eeeeee;
    display: flex;
    flex-direction: column;
    background-color: #ffffff;
}

.item-header {
    padding: 0.5rem 1rem;
    border-bottom: 1px solid #eeeeee;
}

.item-name {
    font-weight: 600;
}

.item-info {
    padding: 0.5rem 1rem;
    font-size: 0.875rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.status-label {
    font-weight: 600;
}

.item-description {
    color: #7d7d7d;
}

.weather-icon {
    width: 2rem;
    height: 2rem;
}

.weather-info {
    display: flex;
    align-items: center;
    gap: 0.25rem;
}

@media (max-width: 60em) {
    .item-status-box {
        width: 100%;
    }
}
</style>
